import React from "react";
import AccordionItem from "./AccordionItem";

interface AccordionProps {
  items: {
    title: string | React.JSX.Element;
    content: React.ReactNode;
    isInfo?: boolean;
    information?: string;
    dynamicHeight?: boolean; // dynamicHeightがtrueの場合に限り、子要素の変更に応じて高さを動的に調整します。
    isChildIcon?: boolean; // アイコンの種類
    autoHeight?: boolean; // autoHeightがtrueの場合、コンテンツの高さを自動で調整します。
  }[];
}

/**
 * アコーディオンコンポーネント
 * 複数のアコーディオンアイテムを表示する
 *
 * @param items - アコーディオンアイテムの配列
 */
const Accordion: React.FC<AccordionProps> = ({ items }) => {
  return (
    <div className="accordion">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          isInfo={item.isInfo ?? false}
          information={item.information ?? ""}
          dynamicHeight={item.dynamicHeight ?? false}
          isChildIcon={item.isChildIcon ?? false}
          autoHeight={item.autoHeight ?? false}
        >
          {item.content}
        </AccordionItem>
      ))}
    </div>
  );
};

export default Accordion;
